<template>
  <div v-if="userLoaded">
    <div
      class="sidebar-left sidebar-fixed h-100 w-100"
      :class="{ 'sidebar-toggled': !sidebarIsOpen }"
    >
      <div class="main-system" :class="{ blur: showNotifications }">
        <div
          class="system-overlay"
          v-if="showNotifications"
          v-on:click="hideNotifications"
        ></div>

        <main-sidebar></main-sidebar>

        <div class="main-system-body">
          <top-bar v-on:toggled="toggleSidebar"></top-bar>

          <div class="container-fluid view-container">
            <preloader
              v-if="
                preloaderHandler &&
                  preloaderHandler.queue &&
                  preloaderHandler.queue.length
              "
            ></preloader>
            <router-view></router-view>
          </div>
        </div>
      </div>

      <notifications-sidebar
        :hide-sidebar="!showNotifications"
      ></notifications-sidebar>
    </div>
  </div>
  <div v-else>
    <preloader></preloader>
  </div>
</template>

<style lang="scss">
@import '../assets/style/sass/axis.scss';
@import '../assets/style/css/animate.min.css';
@import '../assets/style/css/fonts.css';
</style>

<script>
import MainSidebar from './Layout/MainSidebar.vue';
import TopBar from './Layout/TopBar.vue';
import NotificationsSidebar from './Layout/NotificationsSidebar.vue';
import PreloaderHandler from '../Classes/PreloaderHandler';

export default {
  components: {
    MainSidebar,
    TopBar,
    NotificationsSidebar
  },

  data() {
    return {
      sidebar: false,
      preloaderHandler: PreloaderHandler
    };
  },

  computed: {
    showNotifications() {
      return this.$store.state.Notifications.show;
    },

    sidebarIsOpen() {
      return !this.$store.state.hideSidebar;
    },

    userLoaded() {
      return !!Object.keys(this.$store.getters.user).length;
    }
  },

  methods: {
    toggleSidebar() {
      this.sidebar = !this.sidebar;
      this.$store.commit('toggleSidebar', this.sidebar);
    },

    hideNotifications() {
      this.$store.commit('Notifications/toggle');
    }
  }
};
</script>
